import { PartnerClientMonthReport } from 'types/partnerClientManagerTypes';
import { GetPartnerClientMonthReportsService } from 'types/services';
import { m8API } from '../m8';
import { normalizeM8ClientIncomeHistoryRecord } from '../utils/normalizeM8ClientIncomeHistoryRecord';

export const getPartnerClientMonthReports: GetPartnerClientMonthReportsService = async (
  clientId
) => {
  const partnerClientMonthReports: PartnerClientMonthReport[] = [];

  for (let page = 0; page >= 0; page += 1) {
    const m8IncomeHostoryRecords = await m8API.partner.getClientIncomeHistory({
      idClient: clientId,
      page,
    });

    if (m8IncomeHostoryRecords.length > 0) {
      m8IncomeHostoryRecords.forEach((m8IncomeHostoryRecord) => {
        partnerClientMonthReports.push(
          normalizeM8ClientIncomeHistoryRecord(
            m8IncomeHostoryRecord
          ).toPartnerClientMonthReport()
        );
      });
    } else {
      break;
    }
  }

  return partnerClientMonthReports.sort((nextReport, prevReport) => {
    return (
      new Date(prevReport.period.endDateISO).getTime() -
      new Date(nextReport.period.endDateISO).getTime()
    );
  });
};
